import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "skyline_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token);
  return data;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/admin/me`, { headers: authHeader() });
  return data;
};

export const fetchBlockedDates = async (cabin) => {
  const { data } = await axios.get(`${API}/cabins/${cabin}/blocked-dates`);
  return data.dates; // array of "YYYY-MM-DD"
};

export const setBlockedDates = async (cabin, dates, block) => {
  const { data } = await axios.post(
    `${API}/admin/cabins/${cabin}/blocked-dates`,
    { dates, block },
    { headers: authHeader() }
  );
  return data.dates;
};
